import React from "react"
import PropTypes from "prop-types"

import ServiceCard from "./service_card"
import { serviceShape } from "app/lib/shared_prop_types"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

export class RelatedServices extends React.Component {
  componentDidMount() {
    //track when user access directly search, eg: http://ifttt.me/search/query/pocket?tab=service
    logIFTTTNextAction("page_viewed", {
      location_type: this.props.location,
      object_type: "services",
      object_id: this.props.searchTerm,
    })
  }

  render() {
    return (
      <div className="search-body">
        <div className="services-container-static-frame">
          <div className="services-container">
            <ul className="service-cards">
              {this.props.services.map((service, idx) => {
                return (
                  <ServiceCard
                    service={service}
                    key={idx}
                    position={idx}
                    term={this.props.searchTerm}
                    path={this.props.path(service)}
                  />
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
export default RelatedServices

RelatedServices.propTypes = {
  services: PropTypes.arrayOf(serviceShape),
  searchTerm: PropTypes.string,
  path: PropTypes.func.isRequired,
  location: PropTypes.string.isRequired,
}

RelatedServices.defaultProps = {
  services: [],
}
